export const costs = [
  'Sleepless nights translating complex mining and materials concepts',
  'Improvised explanations from disorganized technical materials',
  "Disconnected colleagues who don't see critical minerals relevance",
  'Weekends building technical references and project analyses from scratch',
  'No clear answers when professionals ask technical questions',
];
